export const translations = {
  rights: {
    id: "FOOTER.ROUTE.RIGHTS",
    defaultMessage: "",
  },
  builtBy: {
    id: "FOOTER.ROUTE.BUILT_BY",
    defaultMessage: "",
  },
};
